'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React, { useEffect, useState } from 'react';
import { MdFavoriteBorder, MdFavorite } from 'react-icons/md';
import { Button } from 'reactstrap';
import { useSessionStorage } from 'usehooks-ts';
import { useUser } from '../contexts/UserContext';
import axiosInstance from '../utils/axios';
import { logSentryError } from '../utils/logSentry';
import LoginModal from './LoginModal';
import capitalizeFirstLetter from '../utils/capitalizeFirstLetter';
import { getI18nUtils } from '../i18n/i18n-utils';

function JobLikeButton({
  job,
  withText = false,
  borderColor = '#adb5bd',
  dictionary,
}: {
  job: Job | JobMatch;
  withText?: boolean;
  borderColor?: string;
  dictionary: Record<string, string>;
}): JSX.Element {
  const { candidate, setCandidate, isLoggedIn } = useUser();
  const { formatMessage } = getI18nUtils(dictionary);
  const [animateFavorite, setAnimateFavorite] = useState<boolean>(false);
  const [loginModalOpen, setLoginModalOpen] = useState<boolean>(false);
  const [, setSessionLikedJob] = useSessionStorage<string | null>('likedJob', null);

  const liked = !!(isLoggedIn && candidate?.favoriteJobIds?.includes(job.id));

  useEffect(() => {
    if (loginModalOpen && isLoggedIn) setLoginModalOpen(false);
  }, [loginModalOpen, isLoggedIn]);

  const likeHandler = async (e) => {
    e.preventDefault();

    if (!isLoggedIn) {
      setSessionLikedJob(job.id);

      return setLoginModalOpen(true);
    }

    try {
      if (liked) {
        await axiosInstance.delete(`/favorites`, { data: { jobIds: [job.id] } });
        setAnimateFavorite(false);
        setCandidate((prev) => ({
          ...prev,
          favoriteJobIds: prev.favoriteJobIds?.filter((jobId) => jobId !== job.id),
        }));
      } else {
        await axiosInstance.post(`/favorites/${job.id}`);
        setAnimateFavorite(true);
        setCandidate((prev) => {
          const updatedFavoriteJobIds = prev?.favoriteJobIds ? [...prev.favoriteJobIds, job.id] : [job.id];
          return {
            ...prev,
            favoriteJobIds: updatedFavoriteJobIds,
          };
        });
      }
    } catch (error) {
      logSentryError(error);
    }
  };

  return (
    <>
      <div className="d-inline-block">
        <Button
          color="white"
          className={`like-button d-flex align-items-center position-relative ${
            withText ? 'border p-3 justify-content-center' : 'p-0 iconOnly'
          }`}
          onClick={(e) => likeHandler(e)}
        >
          <div className="d-flex align-items-center me-1">
            <MdFavoriteBorder
              size={20}
              className={`${withText ? 'ms-2' : 'mx-auto'} ${liked ? '' : 'show'}`}
              color={borderColor}
            />
            <MdFavorite
              size={20}
              className={`${withText ? 'ms-2' : 'mx-auto'} ${liked ? 'show' : ''} ${animateFavorite ? 'bounce' : ''}`}
              color="#e2001a"
            />
          </div>
          {withText && <span className="ms-3 text-nowrap">{capitalizeFirstLetter(formatMessage({ id: 'job-like' }))}</span>}
        </Button>
      </div>
      {loginModalOpen && <LoginModal toggle={() => setLoginModalOpen((prev) => !prev)} dictionary={dictionary} />}
    </>
  );
}

export default JobLikeButton;
